import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RulesTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getRules(context, lang, udid, internalIdList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalIdList };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/list', item, options);
  }

  public getRuleActions(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.get(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/actions', options);
  }

  public addRule(context, lang, udid, centerInternalId, turnDeskInternalId, ruleAction, ruleOperator, ruleValue, ruleOrder) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, turnDeskInternalId, ruleAction, ruleOperator, ruleValue, ruleOrder };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/save', item, options);
  }

  public updateRule(context, lang, udid, internalId, ruleOrder, ruleAction, ruleOperator, ruleValue, centerInternalId, turnDeskInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, ruleOrder, ruleAction, ruleOperator, ruleValue, centerInternalId, turnDeskInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/save', item, options);
  }
  public updateRulesOrder(context, lang, udid, rules) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.post(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/update/order', rules, options);
  }
  public deleteRule(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnDeskRuleMaintenance/delete', item, options);
  }
}
